<ph-card *ngIf="payload" flat [heading]="payload.title">
    <ph-badge slot="actions" *ngIf="payload.badge" variant="light" color="blue">{{ payload.badge }}</ph-badge>

    <ph-stack gap="tight">
        <ph-list-row *ngFor="let item of payload.items; let i = index; trackBy: trackByIndex"
                     variant="card" wrap
                     [expandable]="hasDetail(item)"
                     [heading]="item.title || item.recommendation || 'Suggestion'"
                     [meta]="item.meta || ''"
                     [note]="item.tag || ''"
                     [aside]="item.value || ''"
                     [open]="isOpen(i)"
                     (ph-select)="toggle(i, item)">
            <ph-link-button slot="actions" *ngIf="safeHref(item) as href" size="small" icon="arrow-square-out" [attr.href]="href" (click)="openRecord($event, href)">Open</ph-link-button>
            <ph-stack slot="detail" gap="tight" *ngIf="isOpen(i)">
                <ph-hint *ngIf="item.reason">{{ item.reason }}</ph-hint>
                <ph-hint *ngIf="item.confidencePct != null">{{ item.confidencePct }}% confident</ph-hint>
                <ph-button *ngIf="item.recommendation" size="small"
                           [variant]="buttonVariant(item)" [mode]="buttonMode(item)"
                           (click)="onItemAction(item)">{{ item.recommendation }}</ph-button>
            </ph-stack>
        </ph-list-row>
    </ph-stack>

    <ph-hint slot="footer" *ngIf="payload.footnote">{{ payload.footnote }}</ph-hint>
</ph-card>
